export const DEAL_RENT_HEADER_NEW_ITEM = 'deal_rent_head_new_item';
export const SUBURBAN_BUILDING_ITEM = 'sub_desktop_hom_691_new_header_csp';

export const EXPERIMENTS = [DEAL_RENT_HEADER_NEW_ITEM, SUBURBAN_BUILDING_ITEM];
